import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function FixData(myStr){
  myStr = myStr.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return myStr;
}

function Shop() {
  const classes = useStyles();
  /*
  const shopListAry = [
    {"range": 'hachionohe'},
    {"range": 'gonohe-shingou'},
    {"range": 'sannohe-nangou-takko-hashikami'},
    {"range": 'misawa-oirase-rokunohe-rokkasho'},
    {"range": 'towada-shichinohe'},
    {"range": 'touhoku'},
    {"range": 'noheji-yokohama'},
    {"range": 'mutsu-higashidoori'},
    {"range": 'aomori'},
    {"range": 'hirono'},
    {"range": 'kuji-noda'},
    {"range": 'karumai-kunohe'},
    {"range": 'ninohe-ichinohe'},
  ];
  */
  const shopListAry = [
    'hachinohe',
    'gonohe-shingou',
    'sannohe-nangou-takko-hashikami',
    'misawa-oirase-rokunohe-rokkasho',
    'towada-shichinohe',
    'touhoku',
    'noheji-yokohama',
    'mutsu-higashidoori',
    'aomori',
    'hirono',
    'kuji-noda',
    'karumai-kunohe',
    'ninohe-ichinohe',
  ];
  const shopRangeAry = [
    '八　戸',
    '五戸・新郷',
    '三戸・南部・田子・階上',
    '三沢・おいらせ・六戸・六ケ所',
    '十和田・七戸',
    '東　北',
    '野辺地・横浜',
    'むつ・東通',
    '青　森',
    '洋　野',
    '久慈・野田',
    '軽米・九戸',
    '二戸・一戸',
  ];
  let shopList = "";
  let json = "";
  let shopRange = "";
  let shopListObjAry = [];
  let shopListObj = "";

  for (var i in shopListAry){
    json = require("./data/shop/" + shopListAry[i] + ".json");
    shopList = json.map((shop, index) =>
      <Grid item xs={12} md={4} key={index}>
        <Typography className="font-weight-bold my-1" variant="subtitle1" component="h2">
          {FixData(shop.name)}
        </Typography>
        <Divider />
        <div><LocalShippingIcon className="px-1" />{shop.area}</div>
        <div><PhoneEnabledIcon className="px-1" />{shop.tel}</div>
      </Grid>
    );
    shopRange = (
      <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
        {shopRangeAry[i]}
      </Typography>
    );
    shopListObj = (
      <Box my={8}>
        {shopRange}
        <Grid className="px-3" spacing={4} container direction="row" justify="left">
          {shopList}
        </Grid>
      </Box>
    );
    shopListObjAry.push(shopListObj);
  }

  return (
    <div className={classes.root}>
      <div className="wraper">
        {shopListObjAry}
      </div>
    </div>
  );
}
export default Shop;
